<template>
  <div>
    <div class="d-flex justify-content-between container-button">
      <div />
      <div>
        <b-button
          variant="outline-secondary"
          class="ml-1"
          @click="confirmReject"
        >
          <span class="align-middle">Reject</span>
          <feather-icon
            icon="XCircleIcon"
            class="ml-50"
          />
        </b-button>
        <b-button
          variant="primary"
          class="ml-1"
          @click="confirmApprove"
        >
          <span class="align-middle">Approve</span>
          <feather-icon
            icon="CheckCircleIcon"
            class="ml-50"
          />
        </b-button>
      </div>
    </div>
    <popup-approve ref="approvePopup" />
    <popup-reject ref="rejectPopup" />
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import PopupApprove from '@/views/component/PopupApproveCampaign.vue'
import PopupReject from '@/views/component/PopupRejectCampaign.vue'
import { mapMutations } from 'vuex'

export default {
  components: {
    BButton,
    PopupApprove,
    PopupReject,
  },
  directives: {
    Ripple,
  },
  computed: {
    // ...mapGetters('campaign', {
    //   getListReason: 'getListReason',
    // }),
  },
  methods: {
    // confirm texrt
    ...mapMutations('campaign', {
      setStatus: 'SET_STATUS_APPROVE',
    }),
    confirmText() {
      this.$swal({
        title: 'Approve this campaign?',
        text: '',
        icon: 'warning',
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonText: 'Approve',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$swal({
            icon: 'success',
            title: 'Approved!',
            text: '',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },

    // comfirm button color
    confirmApprove() {
      this.setStatus(2)
      this.$refs.approvePopup.showModal()
    },
    confirmReject() {
      this.setStatus(3)
      this.$refs.rejectPopup.showModal()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
